import { createError } from 'h3';
import type { IRssPageItem, IRssPageRequestBody, IRssPageRequestOptions, IRssPageResponse } from '~/types/types';
import { useJwtTokenStore } from '~/stores/jwtTokenStore';
import { reloadAppIfExpired } from '~/utils/TokenRefresher';

export async function getRssPageData(locale: string, rssLink: string, orderBy: string|null): Promise<IRssPageItem[]> {
    const body: IRssPageRequestBody = {
        'rss': rssLink,
        'invalidateCache': false
    };

    if (orderBy) {
        body['orderBy'] = orderBy;
    }

    const options: IRssPageRequestOptions = {
        headers: {
            'Authorization': 'Bearer ' + useJwtTokenStore().getMrApiToken,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Accept-Language': locale,
        },
        baseURL: useRuntimeConfig().public.timelineApi.url,
        method: 'POST',
        body: body,
    };

    const { data, error } = await useFetch<IRssPageResponse>('/rss/items', options);

    if (error.value) {
        if (reloadAppIfExpired(error.value.statusCode ?? 0)) {
            return [];
        }

        throw createError({ statusCode: 500, name: 'Rss Page API Server Error', statusMessage: JSON.stringify(error.value.data) });
    }

    if (!data.value || !data.value.data || Object.keys(data.value.data).length === 0) {
        throw createError({ statusCode: 404, name: 'Rss Page API Resource Not Found', statusMessage: 'Rss Page Data Not Found' });
    }

    return data.value.data;
}
